import { CompanyUserWithUserAndRole } from '@shared/types/companies.types'
import { DefaultRole } from '@shared/types/roles.types'
import { WorkspaceMember } from '@shared/types/workspaces.types'

export const getAvatarName = (name: string, lastName: string): string =>
  name.charAt(0) + lastName.charAt(0)

export const parseLastLoginAt = (
  lastLoginAt: string,
  timezone: string | null
): string => {
  const date = new Date(lastLoginAt)

  const formatter = new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: timezone || 'Europe/Madrid'
  })

  const formattedParts = formatter.formatToParts(date)

  let day = '',
    month = '',
    year = '',
    hour = '',
    minute = ''

  for (const part of formattedParts) {
    switch (part.type) {
      case 'day':
        day = part.value
        break
      case 'month':
        month = part.value
        break
      case 'year':
        year = part.value
        break
      case 'hour':
        hour = part.value
        break
      case 'minute':
        minute = part.value
        break
    }
  }

  return `Último acceso: ${day} de ${month} de ${year} a las ${hour}:${minute}`
}

export const isDefaultRole = (role: string): role is DefaultRole =>
  Object.values(DefaultRole).includes(role as DefaultRole)

export const hasMoreFullAccessUsers = (
  members: WorkspaceMember[] | CompanyUserWithUserAndRole[],
  currentUserId: string
) => {
  if (!members) return false

  const fullAccessUsers = members.filter(
    member => member.role.fullAccess && member.user.id !== currentUserId
  )

  return fullAccessUsers.length > 0
}
